export function setHistory(state, payload) {
  state.history = payload;
}
